<template>
  <v-container>
    <h1>{{ $store.getters.dictionaryName }} / Categories</h1>
    <TranslatedCategoriesTable v-on:edit="edit($event)"></TranslatedCategoriesTable>
    <TranslatedCategoryDialog v-model="dialog" :model="model"></TranslatedCategoryDialog>
  </v-container>
</template>

<script>
import TranslatedCategoriesTable from '../components/TranslatedCategoriesTable'
import TranslatedCategoryDialog from '../components/TranslatedCategoryDialog'

export default {
  components: { TranslatedCategoryDialog, TranslatedCategoriesTable },
  data () {
    return {
      model: null,
      dialog: false
    }
  },
  methods: {
    edit (model) {
      this.model = model
      this.dialog = true
    }
  }
}
</script>
